module.exports = __webpack_public_path__ + "static/media/carecredit_full_logo.c2b85cd8.png";